import CloseLargeIcon from '@8x8/oxygen-icon/icons/CloseLargeIcon'
import styled from 'styled-components'
import { Flex, ColumnFlex, FlexCentered } from '~/components/common/containers'

export const StyledCloseLargeIcon = styled(CloseLargeIcon)`
  cursor: pointer;
  margin: auto 0;
`

export const Container = styled.div`
  box-sizing: border-box;
  padding: 16px;
`

export const TitleContainer = styled(Flex)`
  justify-content: space-between;
  line-height: 32px;
  margin-bottom: 24px;
`

export const Title = styled.h1`
  color: #1c2025;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  margin: 0;
  padding: 0;
`

export const BillToContainer = styled(ColumnFlex)`
  margin-bottom: 32px;
  background: #F0F3F7;
  border-radius: 3px;
  padding: 8px 16px;
`

export const BillToLabel = styled.div`
  color: #5E6D7A;
  line-height: 24px;
`

export const BillToInfoLabel = styled.div`
  line-height: 24px;
  color: #1C2025;
`
export const UnpaidInvoicesLabel = styled.div`
  font-weight: 600;
  font-size: 19px;
  line-height: 28px;
  color: #000000;
  margin-bottom: 16px;
`

export const InvoiceRow = styled(FlexCentered)`
  height: 56px;
`

export const LabelInvoiceId = styled.div`
  color: #000000;
  margin-right: 16px;
`

export const ViewInvoiceDetailsLink = styled.div`
  font-weight: 600;
  color: #0376DA;
  cursor: pointer;
`

export const TotalAmountLabel = styled.div`
  color: #5E6D7A;
  margin-right: 24px;
`

export const LabelAmountDue = styled(TotalAmountLabel)`
  margin-left: auto;
`

export const LabelAmount = styled.div`
  font-weight: 600;
  color: #000000;
  text-align: right;
  width: 60px;
`

export const TotalAmountDueContainer = styled(Flex)`
  margin: 24px 0 24px auto;
  height: 24px;
  justify-content: flex-end;
`
